import Icon from '../../components/Icon.vue'

Icon.register({"brands/youtube-square":{"width":448,"height":512,"paths":[{"d":"M186.8 202.1L282 256.2 186.8 310.3V202.1zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM406 256.3S406 196.7 398.4 168.1C394.2 152.3 381.9 139.9 366.2 135.7 337.9 128 224 128 224 128S110.1 128 81.8 135.7C66.1 139.9 53.8 152.3 49.6 168.1 42 196.6 42 256.3 42 256.3S42 315.9 49.6 344.5C53.8 360.3 66.1 372.2 81.8 376.4 110.1 384 224 384 224 384S337.9 384 366.2 376.3C381.9 372.1 394.2 360.2 398.4 344.4 406 315.9 406 256.3 406 256.3z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/brands/youtube-square.js